var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#0071BC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.128 8.016C11.7973 8.016 11.52 7.904 11.296 7.68C11.072 7.456 10.96 7.17867 10.96 6.848C10.96 6.51733 11.072 6.24 11.296 6.016C11.52 5.792 11.7973 5.68 12.128 5.68C12.448 5.68 12.72 5.792 12.944 6.016C13.168 6.24 13.28 6.51733 13.28 6.848C13.28 7.17867 13.168 7.456 12.944 7.68C12.72 7.904 12.448 8.016 12.128 8.016ZM13.024 9.184V18H11.2V9.184H13.024Z",
    fill: "#0071BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenter);
export default __webpack_public_path__ + "static/media/help-center.061d1142e7adddadfdf736e246ebbafe.svg";
export { ForwardRef as ReactComponent };